import { FC, useContext } from 'react';
import styled from 'styled-components';

import { getImage } from '@/lib/fetchAPI';
import { parseHTML } from '@/lib/parse';
import { translate } from '@/lib/translate';
import { GlobalContext } from '@/pages/_app';

const Post: FC<any> = ({ data }) => {
	const { lang } = useContext(GlobalContext);

	const title = data?.article?.title;
	const description = data?.article?.shortDescription?.substring(0, 100);

	return (
		<Wrapper href={'/' + lang + '/blog/post/' + data?.url}>
			<ImageWrapper>
				<picture>
					<Image
						src={getImage(data?.preview)} // TODO: check the image
						alt={translate(lang, {
							en: `Blog Viber ${data?.url}`,
							ru: `Блог Viber ${data?.url}`,
							ua: `Блог Viber ${data?.url}`,
						})}
					/>
				</picture>
			</ImageWrapper>

			<Content>
				{title ? <Title>{parseHTML(title)}</Title> : null}

				<Paragraph>{description}</Paragraph>
			</Content>
		</Wrapper>
	);
};

const Wrapper = styled.a`
	color: var(--color-purple);
	text-decoration: none;
`;

const ImageWrapper = styled.div`
	width: 100%;
	padding-top: 48%;
	position: relative;
	overflow: hidden;
	border-radius: 30px;
	margin-bottom: 25px;
	mask-image: radial-gradient(white, black);

	&:hover {
		img {
			transform: scale(1.08);
		}
	}

	@media (max-width: 600px) {
		border-radius: 20px;
	}

	@media (max-width: 400px) {
		border-radius: 15px;
	}
`;

const Image = styled.img`
	position: absolute;
	max-width: 100%;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
	top: 0;
	left: 0;
	display: block;
	border-radius: 30px;
	transition: 0.3s;

	@media (max-width: 600px) {
		margin-bottom: 12px;
		border-radius: 20px;
	}

	@media (max-width: 400px) {
		margin-bottom: 12px;
		border-radius: 15px;
	}
`;

const Content = styled.div`
	box-sizing: border-box;
	padding-left: 15px;
	padding-right: 15px;

	@media (max-width: 660px) {
		padding: 0;
	}
`;

const Title = styled.h3`
	font-family: var(--font-sans);

	font-size: 25px;
	line-height: 35px;
	color: var(--color-purple);

	@media (max-width: 1100px) {
		font-size: 20px;
		line-height: 28px;
	}

	@media (max-width: 1000px) {
		font-size: 19px;
	}

	@media (max-width: 600px) {
		font-size: 18px;
		line-height: 27px;
	}

	@media (max-width: 535px) {
		font-size: 22px;
		line-height: 29px;
	}
`;

const Paragraph = styled.div`
	width: 100%;
	max-width: 100%;
	margin-top: 10px;
	font-family: var(--font-sans);

	font-size: 18px;
	line-height: 25px;
	color: var(--color-purple-50);

	@media (max-width: 1000px) {
		font-size: 16px;
		margin-top: 4px;
		line-height: 24px;
	}

	@media (max-width: 600px) {
		font-size: 14px;
		margin-top: 5px;
		line-height: 24px;
	}

	@media (max-width: 535px) {
		font-size: 16px;
		line-height: 25px;
	}
`;

export default Post;
